import { Loader2 } from "lucide-react";
import { useAppPartySocket } from "~/app/hooks/useAppPartySocket";

import { TooltipProvider } from "@/components/ui/tooltip";

import { AnalyticsProvider } from "../Analytics/AnalyticsProvider";
import { LogOutTracker } from "../Analytics/LogOutTracker";
import { UserIdentifier } from "../Analytics/UserIdentifier";
import { CallManager } from "../Call/CallManager";
import { NetworkStatusProvider } from "../NetworkStatus/NetworkStatusProvider";
import { DesktopAuth } from "./DesktopAuth";
import { useAuth } from "./UnifiedAuthProvider";

const POSTHOG_ENABLED = import.meta.env.VITE_POSTHOG_ENABLED;
const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY;

export function DesktopApp() {
  const { isAuthenticated, isLoading, authenticate } = useAuth();
  const partySocket = useAppPartySocket({ room: "waiting-room" });

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="flex items-center space-x-2">
          <Loader2 className="h-4 w-4 animate-spin" />
          <span>Loading...</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <AnalyticsProvider
        posthogKey={POSTHOG_KEY}
        posthogEnabled={POSTHOG_ENABLED}
      >
        <LogOutTracker />
        <DesktopAuth onAuthenticate={(code) => authenticate({ code })} />
      </AnalyticsProvider>
    );
  }

  return (
    <AnalyticsProvider
      posthogKey={POSTHOG_KEY}
      posthogEnabled={POSTHOG_ENABLED}
    >
      <NetworkStatusProvider>
        <TooltipProvider>
          <main className="min-h-screen" data-testid="app-loaded">
            <UserIdentifier />
            <CallManager partySocket={partySocket} />
          </main>
        </TooltipProvider>
      </NetworkStatusProvider>
    </AnalyticsProvider>
  );
}
